
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TweetsSection = () => {
  const tweets = [
    { id: '1910322024947581287', title: 'Tirzepatide Experience' },
    { id: '1909203295849021941', title: 'Weight Management Journey' },
    { id: '1728831901631451170', title: 'Huberman Lab on Nutrition' },
    { id: '1891502878160040137', title: 'Science-Based Health Protocols' },
    { id: '1744452563884208479', title: 'Carnivore Diet Insights' },
  ];

  const accountsToFollow = [
    { handle: 'PeterAttiaMD', name: 'Peter Attia, MD' },
    { handle: 'hubermanlab', name: 'Andrew Huberman, PhD' },
    { handle: 'paulsaladinomd', name: 'Paul Saladino, MD' },
  ];

  return (
    <div className="space-y-8">
      <Card className="overflow-hidden">
        <CardHeader className="p-4 md:p-6 pb-0">
          <CardTitle className="text-lg md:text-xl">Health Experts to Follow</CardTitle>
        </CardHeader>
        <CardContent className="p-4 md:p-6 pt-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {accountsToFollow.map((account) => (
              <a
                key={account.handle}
                href={`https://x.com/${account.handle}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center p-4 border rounded-lg hover:bg-slate-50 transition-colors"
              >
                <div className="flex flex-col">
                  <span className="font-medium">{account.name}</span>
                  <span className="text-sm text-muted-foreground">@{account.handle}</span>
                </div>
              </a>
            ))}
          </div>
        </CardContent>
      </Card>
      
      <Card className="overflow-hidden">
        <CardHeader className="p-4 md:p-6">
          <CardTitle className="text-lg md:text-xl">X Posts</CardTitle>
        </CardHeader>
        <CardContent className="p-4 md:p-6 pt-0">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
            {tweets.map((tweet) => (
              <iframe
                key={tweet.id}
                scrolling="no"
                frameBorder="0"
                allowTransparency={true}
                style={{width: '100%', minHeight: '550px'}}
                className="twitter-tweet"
                src={`https://platform.twitter.com/embed/Tweet.html?id=${tweet.id}`}
                title={`Twitter Tweet - ${tweet.id}`}
              ></iframe>
            ))}
          </div>
        </CardContent>
      </Card>
      
      <script defer src="https://platform.twitter.com/widgets.js"></script>
    </div>
  );
};

export default TweetsSection;

